import { Column } from '@components/LinearLayout';
import { PSmall } from '@components/Typography';
import styled from 'styled-components';

export const ExpandableCardRoot = styled(Column)`
  background-color: #f3f4f5;
  border-radius: ${({ theme }) => theme.borderRadius.radius5};
  animation: height 2s ease-in-out forwards;
  overflow: hidden;
  padding: 1rem 2rem;
  min-height: 10rem;
  gap: 0.7rem;
`;
export const RegularText = styled(PSmall)`
  font-size: ${({ theme }) => theme.fontSize.size15};
  font-weight: ${({ theme }) => theme.fontWeight.weight400};
  color: ${({ theme }) => theme.color.shadeGrey4};
  line-height: ${({ theme }) => theme.lineHeight.height150};
`;

export const ShowMore = styled.div`
  text-align: center;
  color: ${({ theme }) => theme.color.gdprGrey2};
  font-size: ${({ theme }) => theme.fontSize.size14};
  padding-top: 0.5rem;
  &:hover {
    outline: none;
    transition: all 0.2s linear;
    text-decoration: none;
    color: ${({ theme }) => theme.color.gdprGrey};
    cursor: pointer;
  }
`;
